export const LOGOUT_REDIRECT_URLS: Record<string, string> = {
  waitlist: 'https://poly.ai/waitlist/',
};
